import { createFileRoute, useParams } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { CourseGradesView } from '@/views/grades/course-grades-view.tsx';

// ADR-015/019: student gradebook (released items + final + mastery) /
// teacher class-wide spreadsheet summary. role-aware via the gradebook endpoint.
export const Route = createFileRoute('/_learner/courses_/$id/grades')({
  component: GradesTab,
});

function GradesTab() {
  const { id } = useParams({ from: '/_learner/courses_/$id/grades' });
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <CourseGradesView courseId={id} user={user} />;
}
